export enum ProductState {
  ACTIVE = 'active',
  PENDING = 'pending',
  INACTIVE = 'selected',
  PENDING_TERMINATION = 'pending-termination',
  CANCELLED = 'null',
}
